export default __webpack_public_path__ + "static/media/challenger.f0c17431.png";